import React from 'react';
import JUNOButton from '../components/JUNOButton';
import useAvailableAssociates from '../../hooks/useAvailableAssociates';
import SocialIcons from '../components/SocialIcons';

import { motion } from 'framer-motion';

interface PartnerConnectModuleProps {
  content: object;
  callConversationOrAssociate: Function;
  schedulePartnerMeeting: Function;
  openExternalUrl: Function;
  trackExternalClick: Function;
  pubnubHereNow: any;
  currentUser: any;
}

const PartnerConnectModule: React.FC<PartnerConnectModuleProps> = ({
  content,
  callConversationOrAssociate,
  schedulePartnerMeeting,
  openExternalUrl,
  trackExternalClick,
  currentUser,
}) => {
  const availableAssociates = useAvailableAssociates(content);
  //@ts-ignore
  const webSite = content.MetaDataSingleValueForKey(
    //@ts-ignore
    CrowdHub_App.META_WEBSITE,
  );
  //@ts-ignore
  const address = content.MetaDataSingleValueForKey(
    //@ts-ignore
    CrowdHub_App.META_ADDRESS,
  );

  //@ts-ignore
  const phoneNumber = content.MetaDataSingleValueForKey(
    //@ts-ignore
    CrowdHub_App.META_PHONE,
  );

  const talkNowBtn = {
    id: 'talknow_button',
    textstyle: '',
    buttonStyle: 'juno_btn_component juno_button juno_mini_button_outline juno_text_lowercase',
    //@ts-ignore
    text: CrowdHub_App.LANG.BUTTON_TALKNOW,
    onClick: () => {
      let associates = availableAssociates.filter(associate => {
        return associate.Id != currentUser.Id;
      });

      let randAssociate = Math.floor(Math.random() * associates.length);
      let associateToCall = associates[randAssociate];
      callConversationOrAssociate(null, associateToCall);
    },
    onKeyDown: e => {
      if (e.key === 'Enter' || e.key === ' ') {
        let associates = availableAssociates.filter(associate => {
          return associate.Id != currentUser.Id;
        });

        let randAssociate = Math.floor(Math.random() * associates.length);
        let associateToCall = associates[randAssociate];
        callConversationOrAssociate(null, associateToCall);
      }
    },
  };

  const scheduleNowButton = {
    id: 'schedulenow_button',
    textstyle: '',
    buttonStyle: 'juno_btn_component juno_button juno_mini_button_outline juno_text_lowercase',
    //@ts-ignore
    text: CrowdHub_App.LANG.SCHEDULE_A_TIME_TO_CHAT,
    onClick: () => {
      schedulePartnerMeeting(content);
    },
    onKeyDown: e => {
      if (e.key === 'Enter' || e.key === ' ') {
        schedulePartnerMeeting(content);
      }
    },
  };

  const websiteButton = {
    id: 'website_button',
    textstyle: '',
    buttonStyle: 'juno_btn_component juno_button juno_button_filled juno_text_uppercase',
    tabindex: 0,
    text: CrowdHub_App.LANG.VISIT_WEBSITE,
    onClick: () => {
      trackExternalClick(content.Id, webSite);
      openExternalUrl(webSite);
    },
    onKeyDown: e => {
      if (e.key === 'Enter' || e.key === ' ') {
        trackExternalClick(content.Id, webSite);
        openExternalUrl(webSite);
      }
    },
  };

  return (
    <div className={`partner_connect_container`}>
      <div className="juno_partner_connect_name">
        {/*@ts-ignore*/}
        {CrowdHub_App.LANG.CONNECT_WITH_US}
      </div>
      {App.INSTANCE?.CurrentUser?.IsLoggedIn() && (
        <>
          {availableAssociates.length > 1 ||
          (availableAssociates.length === 1 && availableAssociates[0].ChatRoom != currentUser.ChatRoom) ? (
            <motion.div whileHover={{ scale: 1.1 }}>
              <JUNOButton {...talkNowBtn}></JUNOButton>
            </motion.div>
          ) : (
            <></>
          )}
          {content.Associates.length > 0 ? (
            <motion.div whileHover={{ scale: 1.1 }}>
              <JUNOButton {...scheduleNowButton}></JUNOButton>
            </motion.div>
          ) : (
            <div>
              {/*@ts-ignore*/}
              {CrowdHub_App.LANG.NO_ASSOCIATES_AVAILABLE}
            </div>
          )}
        </>
      )}
      <SocialIcons content={content} openExternalUrl={openExternalUrl} trackExternalClick={trackExternalClick} />
      {webSite && (
        <motion.div whileHover={{ scale: 1.1 }}>
          <JUNOButton {...websiteButton}></JUNOButton>
        </motion.div>
      )}
      {address && (
        <div className="juno_partner_connect_address">
          <span className="fa-light fa-location-dot" /> {address}
        </div>
      )}
      {phoneNumber && (
        <div className="juno_partner_connect_address">
          <span className="fa-regular fa-phone" /> {phoneNumber}
        </div>
      )}
    </div>
  );
};

export default PartnerConnectModule;
